// Generated from the previously published site's verified plan database.
// Run: node scripts/import-legacy-plans.mjs

export type MobilePlan = {
  id: string;
  name: string;
  brand: string;
  gb: number | null;
  base: number;
  short: number;
  long: number;
  included: boolean;
  checked: string;
  url: string;
  terms?: string;
  supportUrl?: string;
  support: string;
  fees: string;
  rate?: number;
  shortMinutes?: number;
  includedMinutes?: number;
  callChoice?: boolean;
  shop: boolean;
  periodDays?: number | null;
  speedLimited?: boolean;
  notes?: string[];
  sources: string[];
  status: string;
  discountGroups?: unknown[];
  affiliateStatus?: string;
  affiliateUrl?: string | null;
};

export const mobilePlans = [
  {
    "id": "iij_2gb",
    "name": "ギガプラン 2GB",
    "brand": "IIJmio",
    "gb": 2,
    "base": 850,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-11",
    "url": "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
      "https://www.iijmio.jp/hdc/spec/",
      "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_5gb",
    "name": "ギガプラン 5GB",
    "brand": "IIJmio",
    "gb": 5,
    "base": 950,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-11",
    "url": "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
      "https://www.iijmio.jp/hdc/spec/",
      "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_10gb",
    "name": "ギガプラン 10GB",
    "brand": "IIJmio",
    "gb": 10,
    "base": 1400,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-11",
    "url": "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
      "https://www.iijmio.jp/hdc/spec/",
      "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_15gb",
    "name": "ギガプラン 15GB",
    "brand": "IIJmio",
    "gb": 15,
    "base": 1600,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-11",
    "url": "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
      "https://www.iijmio.jp/hdc/spec/",
      "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_25gb",
    "name": "ギガプラン 25GB",
    "brand": "IIJmio",
    "gb": 25,
    "base": 2000,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-11",
    "url": "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://help.iijmio.jp/answer/602dc1d407f19b0012186e68/",
      "https://www.iijmio.jp/hdc/spec/",
      "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_35gb",
    "name": "ギガプラン 35GB",
    "brand": "IIJmio",
    "gb": 35,
    "base": 2400,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-20",
    "url": "https://www.iijmio.jp/gigaplan/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": ["https://www.iijmio.jp/gigaplan/"],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_45gb",
    "name": "ギガプラン 45GB",
    "brand": "IIJmio",
    "gb": 45,
    "base": 3300,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-20",
    "url": "https://www.iijmio.jp/gigaplan/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": ["https://www.iijmio.jp/gigaplan/"],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "iij_55gb",
    "name": "ギガプラン 55GB",
    "brand": "IIJmio",
    "gb": 55,
    "base": 3900,
    "short": 500,
    "long": 1400,
    "included": false,
    "checked": "2026-09-20",
    "url": "https://www.iijmio.jp/gigaplan/",
    "terms": "https://www.iijmio.jp/hdc/spec/",
    "supportUrl": "https://help.iijmio.jp/answer/61172c8ab597a700193174ba/",
    "support": "契約後の店頭サポートなし",
    "fees": "通常初期費用3,300円＋SIM発行手数料。発行手数料はSIMの種類で異なります。",
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": ["https://www.iijmio.jp/gigaplan/"],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "ahamo_30gb",
    "name": "ahamo 40GB（増量中）",
    "brand": "ahamo",
    "gb": 40,
    "base": 2970,
    "short": 0,
    "long": 1100,
    "included": true,
    "checked": "2026-09-18",
    "url": "https://ahamo.com/plan/index.html",
    "terms": "https://ahamo.com/plan/index.html",
    "supportUrl": "https://ahamo.com/news/acscu50000000ifd.html",
    "support": "店頭のWEB手続き支援は有料。端末操作は本人が行います。",
    "fees": "新規・乗り換えの事務手数料0円。店頭WEB手続き支援は別料金です。",
    "rate": 22,
    "shortMinutes": 5,
    "includedMinutes": 5,
    "shop": false,
    "periodDays": null,
    "notes": [
      "通常30GB。2026-08-01〜2026-11-30のデータ増量おためしキャンペーンにより10GB増量中。12月1日からサービス仕様・料金改定の予告あり。将来の条件は公式FAQで確認（2026-10-05確認）。"
    ],
    "sources": [
      "https://ahamo.com/plan/index.html",
      "https://ahamo.com/plan/index.html",
      "https://ahamo.com/news/acscu50000000ifd.html",
      "https://www.docomo.ne.jp/info/notice/page/260729_00.html"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "ahamo_110gb",
    "name": "ahamo大盛り 120GB（増量中）",
    "brand": "ahamo",
    "gb": 120,
    "base": 4950,
    "short": 0,
    "long": 1100,
    "included": true,
    "checked": "2026-09-18",
    "url": "https://ahamo.com/plan/index.html",
    "terms": "https://ahamo.com/plan/index.html",
    "supportUrl": "https://ahamo.com/news/acscu50000000ifd.html",
    "support": "店頭のWEB手続き支援は有料。端末操作は本人が行います。",
    "fees": "新規・乗り換えの事務手数料0円。店頭WEB手続き支援は別料金です。",
    "rate": 22,
    "shortMinutes": 5,
    "includedMinutes": 5,
    "shop": false,
    "periodDays": null,
    "notes": [
      "通常110GB。2026-08-01〜2026-11-30のデータ増量おためしキャンペーンにより10GB増量中。12月1日からサービス仕様・料金改定の予告あり。将来の条件は公式FAQで確認（2026-10-05確認）。"
    ],
    "sources": [
      "https://ahamo.com/plan/index.html",
      "https://ahamo.com/plan/index.html",
      "https://ahamo.com/news/acscu50000000ifd.html",
      "https://www.docomo.ne.jp/info/notice/page/260729_00.html"
    ],
    "status": "verified",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "nihon_minna_20gb",
    "name": "合理的みんなのプラン 20GB",
    "brand": "日本通信SIM",
    "gb": 20,
    "base": 1390,
    "short": 0,
    "long": 1600,
    "included": true,
    "callChoice": true,
    "checked": "2026-09-11",
    "url": "https://www.nihontsushin.com/plan/planminna.html",
    "terms": "https://www.nihontsushin.com/support/support_option_callflat.html",
    "supportUrl": "https://www.nihontsushin.com/plan/planminna.html",
    "support": "問い合わせは日本通信ヘルプデスクへ。スターターパックの店頭販売と契約後の相談は別です。",
    "fees": "初期手数料3,300円。基本容量を超えるデータ利用は、設定した上限の範囲で1GBあたり220円。",
    "affiliateStatus": "未確認",
    "affiliateUrl": null,
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 5,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://www.nihontsushin.com/plan/planminna.html",
      "https://www.nihontsushin.com/support/support_option_callflat.html",
      "https://www.nihontsushin.com/plan/planminna.html"
    ],
    "status": "verified",
    "discountGroups": []
  },
  {
    "id": "nihon_50gb",
    "name": "合理的50GBプラン",
    "brand": "日本通信SIM",
    "gb": 50,
    "base": 2178,
    "short": 0,
    "long": 1200,
    "included": true,
    "callChoice": true,
    "checked": "2026-09-11",
    "url": "https://www.nihontsushin.com/plan/plangbgdvc.html",
    "terms": "https://www.nihontsushin.com/support/support_option_callflat.html",
    "supportUrl": "https://www.nihontsushin.com/plan/plangbgdvc.html",
    "support": "問い合わせは日本通信ヘルプデスクへ。スターターパックの店頭販売と契約後の相談は別です。",
    "fees": "初期手数料3,300円。基本容量を超えるデータ利用は、設定した上限の範囲で1GBあたり220円。",
    "affiliateStatus": "未確認",
    "affiliateUrl": null,
    "rate": 11,
    "shortMinutes": 5,
    "includedMinutes": 5,
    "shop": false,
    "periodDays": null,
    "notes": [],
    "sources": [
      "https://www.nihontsushin.com/plan/plangbgdvc.html",
      "https://www.nihontsushin.com/support/support_option_callflat.html",
      "https://www.nihontsushin.com/plan/plangbgdvc.html"
    ],
    "status": "verified",
    "discountGroups": []
  },
  {
    "id": "rakuten_3gb",
    "name": "Rakuten最強プラン (~3GB)",
    "brand": "楽天モバイル",
    "gb": 3,
    "base": 1078,
    "short": 0,
    "long": 0,
    "shortMinutes": null,
    "includedMinutes": 0,
    "rate": 22,
    "linkApp": true,
    "shop": true,
    "checked": "2026-09-11",
    "status": "verified",
    "url": "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/",
    "terms": "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/",
    "supportUrl": "https://network.mobile.rakuten.co.jp/shop/",
    "support": "ショップで相談可能。対応できる手続き・有料サービスは店舗で確認。",
    "fees": "同一名義の累計4回線目までは事務手数料無料。5回線目以降3,850円。",
    "priceNote": "月3GB以内の場合。3GB超は2,178円、20GB超は3,278円。",
    "notes": [
      "Rakuten Linkアプリ利用を前提に通話追加料0円で比較。標準電話アプリは22円／30秒。0570等は対象外。",
      "無制限でも混雑時等に速度制御の場合があります。"
    ],
    "sources": [
      "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/"
    ],
    "discountGroups": [
      {
        "id": "family",
        "label": "最強家族割",
        "options": [
          {
            "id": "rakuten_family_202609",
            "amount": 110,
            "label": "対象の家族グループに参加",
            "condition": "家族でグループを作成・参加。適用条件を公式で確認。",
            "url": "https://network.mobile.rakuten.co.jp/fee/family/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "rakuten_20gb",
    "name": "Rakuten最強プラン (3~20GB)",
    "brand": "楽天モバイル",
    "gb": 20,
    "base": 2178,
    "short": 0,
    "long": 0,
    "shortMinutes": null,
    "includedMinutes": 0,
    "rate": 22,
    "linkApp": true,
    "shop": true,
    "checked": "2026-09-11",
    "status": "verified",
    "url": "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/",
    "terms": "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/",
    "supportUrl": "https://network.mobile.rakuten.co.jp/shop/",
    "support": "ショップで相談可能。対応できる手続き・有料サービスは店舗で確認。",
    "fees": "同一名義の累計4回線目までは事務手数料無料。5回線目以降3,850円。",
    "priceNote": "月3GB超〜20GBの場合。20GB超は3,278円。",
    "notes": [
      "Rakuten Linkアプリ利用を前提に通話追加料0円で比較。標準電話アプリは22円／30秒。0570等は対象外。",
      "無制限でも混雑時等に速度制御の場合があります。"
    ],
    "sources": [
      "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/"
    ],
    "discountGroups": [
      {
        "id": "family",
        "label": "最強家族割",
        "options": [
          {
            "id": "rakuten_family_202609",
            "amount": 110,
            "label": "対象の家族グループに参加",
            "condition": "家族でグループを作成・参加。適用条件を公式で確認。",
            "url": "https://network.mobile.rakuten.co.jp/fee/family/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "rakuten_unlimited",
    "name": "Rakuten最強プラン (無制限)",
    "brand": "楽天モバイル",
    "gb": null,
    "base": 3278,
    "short": 0,
    "long": 0,
    "shortMinutes": null,
    "includedMinutes": 0,
    "rate": 22,
    "linkApp": true,
    "shop": true,
    "checked": "2026-09-11",
    "status": "verified",
    "url": "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/",
    "terms": "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/",
    "supportUrl": "https://network.mobile.rakuten.co.jp/shop/",
    "support": "ショップで相談可能。対応できる手続き・有料サービスは店舗で確認。",
    "fees": "同一名義の累計4回線目までは事務手数料無料。5回線目以降3,850円。",
    "priceNote": "月20GBを超えて利用した場合。",
    "notes": [
      "Rakuten Linkアプリ利用を前提に通話追加料0円で比較。標準電話アプリは22円／30秒。0570等は対象外。",
      "無制限でも混雑時等に速度制御の場合があります。"
    ],
    "sources": [
      "https://network.mobile.rakuten.co.jp/fee/saikyo-plan/detail/"
    ],
    "discountGroups": [
      {
        "id": "family",
        "label": "最強家族割",
        "options": [
          {
            "id": "rakuten_family_202609",
            "amount": 110,
            "label": "対象の家族グループに参加",
            "condition": "家族でグループを作成・参加。適用条件を公式で確認。",
            "url": "https://network.mobile.rakuten.co.jp/fee/family/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "linemo_best_3gb",
    "name": "ベストプラン (~3GB)",
    "brand": "LINEMO",
    "gb": 3,
    "base": 990,
    "short": 550,
    "long": 1650,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "rate": 22,
    "shop": false,
    "status": "verified",
    "checked": "2026-09-11",
    "url": "https://www.linemo.jp/plan/",
    "terms": "https://www.linemo.jp/support/faq/view/27282",
    "supportUrl": "https://www.linemo.jp/guide/linemo/article037/",
    "support": "オンライン専用。店舗でのサポートなし。",
    "fees": "通常の契約事務手数料3,850円。短期解約の条件は申込時の重要事項説明で確認。",
    "priceNote": "月3GB以内の料金。3GB超〜10GBは2,090円。",
    "notes": [
      "通話オプションの期間限定割引は含みません。"
    ],
    "sources": [
      "https://www.linemo.jp/plan/index.html",
      "https://www.linemo.jp/support/faq/view/27282",
      "https://www.linemo.jp/corporate/agreement/pdf/agreement_yakkan.pdf"
    ],
    "verificationMethod": "公式検索インデックスを含む。ページ本文の直接取得は403。",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "linemo_best_10gb",
    "name": "ベストプラン (~10GB)",
    "brand": "LINEMO",
    "gb": 10,
    "base": 2090,
    "short": 550,
    "long": 1650,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "rate": 22,
    "shop": false,
    "status": "verified",
    "checked": "2026-09-11",
    "url": "https://www.linemo.jp/plan/",
    "terms": "https://www.linemo.jp/support/faq/view/27282",
    "supportUrl": "https://www.linemo.jp/guide/linemo/article037/",
    "support": "オンライン専用。店舗でのサポートなし。",
    "fees": "通常の契約事務手数料3,850円。短期解約の条件は申込時の重要事項説明で確認。",
    "priceNote": "月3GB超〜10GBの料金。",
    "notes": [
      "通話オプションの期間限定割引は含みません。"
    ],
    "sources": [
      "https://www.linemo.jp/plan/index.html",
      "https://www.linemo.jp/support/faq/view/27282",
      "https://www.linemo.jp/corporate/agreement/pdf/agreement_yakkan.pdf"
    ],
    "verificationMethod": "公式検索インデックスを含む。ページ本文の直接取得は403。",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "linemo_bestv_30gb",
    "name": "ベストプランV (30GB)",
    "brand": "LINEMO",
    "gb": 30,
    "base": 2970,
    "short": 0,
    "long": 1100,
    "shortMinutes": 5,
    "includedMinutes": 5,
    "rate": 22,
    "shop": false,
    "status": "verified",
    "checked": "2026-09-11",
    "url": "https://www.linemo.jp/plan/",
    "terms": "https://www.linemo.jp/support/faq/view/27282",
    "supportUrl": "https://www.linemo.jp/guide/linemo/article037/",
    "support": "オンライン専用。店舗でのサポートなし。",
    "fees": "通常の契約事務手数料3,850円。短期解約の条件は申込時の重要事項説明で確認。",
    "priceNote": "",
    "notes": [
      "通話オプションの期間限定割引は含みません。"
    ],
    "sources": [
      "https://www.linemo.jp/plan/index.html",
      "https://www.linemo.jp/support/faq/view/27282",
      "https://www.linemo.jp/corporate/agreement/pdf/agreement_yakkan.pdf"
    ],
    "verificationMethod": "公式検索インデックスを含む。ページ本文の直接取得は403。",
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "nihon_simple_1gb",
    "name": "合理的シンプル290 1GB",
    "brand": "日本通信SIM",
    "gb": 1,
    "base": 290,
    "short": 390,
    "long": 1600,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "rate": 11,
    "shop": false,
    "status": "verified",
    "checked": "2026-09-11",
    "url": "https://www.nihontsushin.com/plan/plansimple.html",
    "terms": "https://www.nihontsushin.com/support/support_option_callflat.html",
    "supportUrl": "https://www.nihontsushin.com/support/",
    "support": "問い合わせは日本通信ヘルプデスクへ。",
    "fees": "初期手数料3,300円。",
    "priceNote": "1GB以内の場合。超過分は1GBあたり220円、設定した上限まで従量課金。",
    "notes": [
      "定額5GBのプランではありません。実際の使用量で請求額が変わります。"
    ],
    "sources": [
      "https://www.nihontsushin.com/plan/plansimple.html",
      "https://www.nihontsushin.com/support/support_option_callflat.html"
    ],
    "discountGroups": [],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "uq_komikomi_value_35gb",
    "base": 3828,
    "gb": 35,
    "short": 0,
    "shortMinutes": 10,
    "long": 1100,
    "includedMinutes": 10,
    "shop": true,
    "discounts": [],
    "notes": [
      "10分超過22円/30秒、定額対象外番号あり。",
      "設定・データ移行など有料サポートあり。"
    ],
    "sourceUrls": [
      "https://www.uqwimax.jp/mobile/plan/komikomi-pv/",
      "https://www.uqwimax.jp/mobile/description/",
      "https://www.uqwimax.jp/mobile/plan/option/tentousettei-support/"
    ],
    "initialFee": {
      "online": 3850,
      "shop": 4950
    },
    "name": "コミコミプランバリュー (35GB)",
    "brand": "UQ mobile",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://www.uqwimax.jp/mobile/plan/komikomi-pv/",
      "https://www.uqwimax.jp/mobile/description/",
      "https://www.uqwimax.jp/mobile/plan/option/tentousettei-support/"
    ],
    "url": "https://www.uqwimax.jp/mobile/plan/komikomi-pv/",
    "terms": "https://www.uqwimax.jp/mobile/plan/komikomi-pv/",
    "supportUrl": "https://www.uqwimax.jp/mobile/description/",
    "fees": "通常初期費用：オンライン3850円／店頭4950円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "uq_tokutoku2_under5",
    "base": 2948,
    "gb": 5,
    "short": 880,
    "shortMinutes": 10,
    "long": 1980,
    "includedMinutes": 0,
    "shop": true,
    "discounts": [
      {
        "sourceId": "uq_jitaku",
        "amount": 1100,
        "condition": "対象の自宅インターネット（ネット＋電話など）またはでんき契約と申込が必要。別途固定回線等の費用。",
        "exclusive": [
          "uq_family"
        ]
      },
      {
        "sourceId": "uq_family",
        "amount": 550,
        "condition": "月末時点で同一セット割グループにカウント対象回線（自身含む）が2回線以上。登録完了翌月から。トクトク2は割引対象、コミコミバリューは人数カウントのみ。UQ・au・WiMAXのグループ登録上限合計10。カウント対象は各料金プラン提供条件書に従い、auやWiMAX全回線を無条件に数えない。自宅セット割が優先。",
        "exclusive": [
          "uq_jitaku"
        ],
        "minimumEligibleLines": 2,
        "sourceUrl": "https://www.kddi.com/extlib/files/corporate/kddi/kokai/keiyaku_yakkan/pdf/kazokuset.pdf"
      },
      {
        "sourceId": "uq_card",
        "amount": 220,
        "condition": "月末の支払方法がau PAYカード。法人対象外。セット割と併用可。",
        "exclusive": []
      }
    ],
    "notes": [
      "基本料金4048円。月の実利用量5GB以下なら1100円減額する同一段階制プラン。under5は独立した5GB契約ではない。",
      "通常22円/30秒。月60分相当660円も選べるが短時間かけ放題とは異なる。",
      "設定・データ移行など有料サポートあり。"
    ],
    "sourceUrls": [
      "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
      "https://www.uqwimax.jp/mobile/description/",
      "https://www.uqwimax.jp/mobile/plan/option/tentousettei-support/"
    ],
    "initialFee": {
      "online": 3850,
      "shop": 4950
    },
    "name": "トクトクプラン2 (~5GB)",
    "brand": "UQ mobile",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
      "https://www.uqwimax.jp/mobile/description/",
      "https://www.uqwimax.jp/mobile/plan/option/tentousettei-support/"
    ],
    "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
    "terms": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
    "supportUrl": "https://www.uqwimax.jp/mobile/description/",
    "fees": "通常初期費用：オンライン3850円／店頭4950円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [
      {
        "id": "set",
        "label": "自宅・家族の条件",
        "options": [
          {
            "id": "uq_jitaku",
            "label": "自宅セット割",
            "amount": 1100,
            "condition": "対象の自宅インターネット（ネット＋電話など）またはでんき契約と申込が必要。別途固定回線等の費用。",
            "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
            "exclusive": [
              "uq_family"
            ]
          },
          {
            "id": "uq_family",
            "label": "家族セット割",
            "amount": 550,
            "condition": "月末時点で同一セット割グループにカウント対象回線（自身含む）が2回線以上。登録完了翌月から。トクトク2は割引対象、コミコミバリューは人数カウントのみ。UQ・au・WiMAXのグループ登録上限合計10。カウント対象は各料金プラン提供条件書に従い、auやWiMAX全回線を無条件に数えない。自宅セット割が優先。",
            "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
            "exclusive": [
              "uq_jitaku"
            ]
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "uq_card",
            "label": "au PAYカードお支払い割",
            "amount": 220,
            "condition": "月末の支払方法がau PAYカード。法人対象外。セット割と併用可。",
            "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
            "exclusive": []
          }
        ]
      }
    ],
    "priceNote": "月の利用量5GB以下の料金。基本4,048円から利用量による1,100円減額。5GB超は4,048円。",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "uq_tokutoku2_30gb",
    "base": 4048,
    "gb": 30,
    "short": 880,
    "shortMinutes": 10,
    "long": 1980,
    "includedMinutes": 0,
    "shop": true,
    "discounts": [
      {
        "sourceId": "uq_jitaku",
        "amount": 1100,
        "condition": "対象の自宅インターネット（ネット＋電話など）またはでんき契約と申込が必要。別途固定回線等の費用。",
        "exclusive": [
          "uq_family"
        ]
      },
      {
        "sourceId": "uq_family",
        "amount": 550,
        "condition": "月末時点で同一セット割グループにカウント対象回線（自身含む）が2回線以上。登録完了翌月から。トクトク2は割引対象、コミコミバリューは人数カウントのみ。UQ・au・WiMAXのグループ登録上限合計10。カウント対象は各料金プラン提供条件書に従い、auやWiMAX全回線を無条件に数えない。自宅セット割が優先。",
        "exclusive": [
          "uq_jitaku"
        ],
        "minimumEligibleLines": 2,
        "sourceUrl": "https://www.kddi.com/extlib/files/corporate/kddi/kokai/keiyaku_yakkan/pdf/kazokuset.pdf"
      },
      {
        "sourceId": "uq_card",
        "amount": 220,
        "condition": "月末の支払方法がau PAYカード。法人対象外。セット割と併用可。",
        "exclusive": []
      }
    ],
    "notes": [
      "基本料金4048円。月の実利用量5GB以下なら1100円減額する同一段階制プラン。under5は独立した5GB契約ではない。",
      "通常22円/30秒。月60分相当660円も選べるが短時間かけ放題とは異なる。",
      "設定・データ移行など有料サポートあり。"
    ],
    "sourceUrls": [
      "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
      "https://www.uqwimax.jp/mobile/description/",
      "https://www.uqwimax.jp/mobile/plan/option/tentousettei-support/"
    ],
    "initialFee": {
      "online": 3850,
      "shop": 4950
    },
    "name": "トクトクプラン2 (5GB超~30GB)",
    "brand": "UQ mobile",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
      "https://www.uqwimax.jp/mobile/description/",
      "https://www.uqwimax.jp/mobile/plan/option/tentousettei-support/"
    ],
    "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
    "terms": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
    "supportUrl": "https://www.uqwimax.jp/mobile/description/",
    "fees": "通常初期費用：オンライン3850円／店頭4950円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [
      {
        "id": "set",
        "label": "自宅・家族の条件",
        "options": [
          {
            "id": "uq_jitaku",
            "label": "自宅セット割",
            "amount": 1100,
            "condition": "対象の自宅インターネット（ネット＋電話など）またはでんき契約と申込が必要。別途固定回線等の費用。",
            "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
            "exclusive": [
              "uq_family"
            ]
          },
          {
            "id": "uq_family",
            "label": "家族セット割",
            "amount": 550,
            "condition": "月末時点で同一セット割グループにカウント対象回線（自身含む）が2回線以上。登録完了翌月から。トクトク2は割引対象、コミコミバリューは人数カウントのみ。UQ・au・WiMAXのグループ登録上限合計10。カウント対象は各料金プラン提供条件書に従い、auやWiMAX全回線を無条件に数えない。自宅セット割が優先。",
            "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
            "exclusive": [
              "uq_jitaku"
            ]
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "uq_card",
            "label": "au PAYカードお支払い割",
            "amount": 220,
            "condition": "月末の支払方法がau PAYカード。法人対象外。セット割と併用可。",
            "url": "https://www.uqwimax.jp/mobile/plan/tokutoku2/",
            "exclusive": []
          }
        ]
      }
    ],
    "priceNote": "月5GB超〜30GBの場合の料金。",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "ymobile_simple3_s",
    "base": 3278,
    "gb": 5,
    "short": 880,
    "shortMinutes": 10,
    "long": 1980,
    "includedMinutes": 0,
    "shop": true,
    "discounts": [
      {
        "sourceId": "ymobile_hikari",
        "amount": 1650,
        "condition": "対象のSoftBank 光/光＋・Air契約と申込。固定回線等別途費用。",
        "exclusive": [
          "ymobile_family",
          "ymobile_denki_tbd",
          "ymobile_cho_otoku"
        ]
      },
      {
        "sourceId": "ymobile_family",
        "amount": 1100,
        "condition": "2回線目以降、最大9回線。家族確認。1回線目は対象外。",
        "exclusive": [
          "ymobile_hikari",
          "ymobile_denki_tbd",
          "ymobile_cho_otoku"
        ]
      },
      {
        "sourceId": "ymobile_card",
        "amount": 330,
        "condition": "PayPayカードを料金支払方法に設定。ゴールドとは択一。",
        "exclusive": [
          "ymobile_card_gold"
        ]
      },
      {
        "sourceId": "ymobile_card_gold",
        "amount": 770,
        "condition": "PayPayカード ゴールド支払。550円＋2026-06-02以降増額220円。年会費11000円別途。旧契約向け特別割引とは増額特典併用不可。 増額220円の適用期間は2026-06-02～終了日未定。契約後12ヶ月等の固定期間制限は記載なし、永年保証ではない。請求締日時点に対象プラン・Gold支払・PayPayカード割適用が必要。",
        "exclusive": [
          "ymobile_card"
        ],
        "bonusStart": "2026-06-02",
        "bonusEnd": null,
        "bonusEndStatus": "終了日未定",
        "sourceUrl": "https://www.ymobile.jp/corporate/open/agreement/pdf/paypay_card_bonus.pdf"
      }
    ],
    "notes": [
      "2026-06-02改定後基本料。旧契約向け特別割引を新規契約に適用しない。",
      "通常または定額超過22円/30秒。定額対象外番号あり。",
      "店舗での設定・データ移行は有料メニューあり。"
    ],
    "sourceUrls": [
      "https://www.ymobile.jp/store/sp/sim/",
      "https://www.ymobile.jp/jusetsu/jusetsu06/",
      "https://www.ymobile.jp/plan/discount/kazokuwari/",
      "https://www.ymobile.jp/plan/discount/ouchiwari/?plan_type=simple1",
      "https://www.ymobile.jp/service/sumahosetup-support/",
      "https://www.ymobile.jp/jusetsu/servicenotes/service_notes.pdf"
    ],
    "initialFee": {
      "onlineStandard": 3850,
      "shop": 4950,
      "campaign": "9月30日までのオンライン手数料無料キャンペーンは終了。通常オンライン手数料3,850円で計算（2026-10-05確認）。"
    },
    "name": "シンプル3 S (5GB)",
    "brand": "Y!mobile",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://www.ymobile.jp/store/sp/sim/",
      "https://www.ymobile.jp/jusetsu/jusetsu06/",
      "https://www.ymobile.jp/plan/discount/kazokuwari/",
      "https://www.ymobile.jp/plan/discount/ouchiwari/?plan_type=simple1",
      "https://www.ymobile.jp/service/sumahosetup-support/",
      "https://www.ymobile.jp/jusetsu/servicenotes/service_notes.pdf"
    ],
    "url": "https://www.ymobile.jp/store/sp/sim/",
    "terms": "https://www.ymobile.jp/store/sp/sim/",
    "supportUrl": "https://www.ymobile.jp/service/sumahosetup-support/",
    "fees": "通常初期費用：オンライン3850円／店頭4950円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [
      {
        "id": "set",
        "label": "自宅・家族の条件",
        "options": [
          {
            "id": "ymobile_hikari",
            "label": "おうち割 光セット(A)",
            "amount": 1650,
            "condition": "対象のSoftBank 光/光＋・Air契約と申込。固定回線等別途費用。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_family",
              "ymobile_denki_tbd",
              "ymobile_cho_otoku"
            ]
          },
          {
            "id": "ymobile_family",
            "label": "家族割引サービス",
            "amount": 1100,
            "condition": "2回線目以降、最大9回線。家族確認。1回線目は対象外。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_hikari",
              "ymobile_denki_tbd",
              "ymobile_cho_otoku"
            ]
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "ymobile_card",
            "label": "PayPayカード割",
            "amount": 330,
            "condition": "PayPayカードを料金支払方法に設定。ゴールドとは択一。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_card_gold"
            ]
          },
          {
            "id": "ymobile_card_gold",
            "label": "PayPayカード ゴールド割（増額分込み）",
            "amount": 770,
            "condition": "PayPayカード ゴールド支払。550円＋2026-06-02以降増額220円。年会費11000円別途。旧契約向け特別割引とは増額特典併用不可。 増額220円の適用期間は2026-06-02～終了日未定。契約後12ヶ月等の固定期間制限は記載なし、永年保証ではない。請求締日時点に対象プラン・Gold支払・PayPayカード割適用が必要。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_card"
            ]
          }
        ]
      }
    ],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "ymobile_simple3_m",
    "base": 4378,
    "gb": 30,
    "short": 880,
    "shortMinutes": 10,
    "long": 1980,
    "includedMinutes": 0,
    "shop": true,
    "discounts": [
      {
        "sourceId": "ymobile_hikari",
        "amount": 1650,
        "condition": "対象のSoftBank 光/光＋・Air契約と申込。固定回線等別途費用。",
        "exclusive": [
          "ymobile_family",
          "ymobile_denki_tbd",
          "ymobile_cho_otoku"
        ]
      },
      {
        "sourceId": "ymobile_family",
        "amount": 1100,
        "condition": "2回線目以降、最大9回線。家族確認。1回線目は対象外。",
        "exclusive": [
          "ymobile_hikari",
          "ymobile_denki_tbd",
          "ymobile_cho_otoku"
        ]
      },
      {
        "sourceId": "ymobile_card",
        "amount": 330,
        "condition": "PayPayカードを料金支払方法に設定。ゴールドとは択一。",
        "exclusive": [
          "ymobile_card_gold"
        ]
      },
      {
        "sourceId": "ymobile_card_gold",
        "amount": 770,
        "condition": "PayPayカード ゴールド支払。550円＋2026-06-02以降増額220円。年会費11000円別途。旧契約向け特別割引とは増額特典併用不可。 増額220円の適用期間は2026-06-02～終了日未定。契約後12ヶ月等の固定期間制限は記載なし、永年保証ではない。請求締日時点に対象プラン・Gold支払・PayPayカード割適用が必要。",
        "exclusive": [
          "ymobile_card"
        ],
        "bonusStart": "2026-06-02",
        "bonusEnd": null,
        "bonusEndStatus": "終了日未定",
        "sourceUrl": "https://www.ymobile.jp/corporate/open/agreement/pdf/paypay_card_bonus.pdf"
      }
    ],
    "notes": [
      "2026-06-02改定後基本料。旧契約向け特別割引を新規契約に適用しない。",
      "通常または定額超過22円/30秒。定額対象外番号あり。",
      "店舗での設定・データ移行は有料メニューあり。"
    ],
    "sourceUrls": [
      "https://www.ymobile.jp/store/sp/sim/",
      "https://www.ymobile.jp/jusetsu/jusetsu06/",
      "https://www.ymobile.jp/plan/discount/kazokuwari/",
      "https://www.ymobile.jp/plan/discount/ouchiwari/?plan_type=simple1",
      "https://www.ymobile.jp/service/sumahosetup-support/",
      "https://www.ymobile.jp/jusetsu/servicenotes/service_notes.pdf"
    ],
    "initialFee": {
      "onlineStandard": 3850,
      "shop": 4950,
      "campaign": "9月30日までのオンライン手数料無料キャンペーンは終了。通常オンライン手数料3,850円で計算（2026-10-05確認）。"
    },
    "name": "シンプル3 M (30GB)",
    "brand": "Y!mobile",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://www.ymobile.jp/store/sp/sim/",
      "https://www.ymobile.jp/jusetsu/jusetsu06/",
      "https://www.ymobile.jp/plan/discount/kazokuwari/",
      "https://www.ymobile.jp/plan/discount/ouchiwari/?plan_type=simple1",
      "https://www.ymobile.jp/service/sumahosetup-support/",
      "https://www.ymobile.jp/jusetsu/servicenotes/service_notes.pdf"
    ],
    "url": "https://www.ymobile.jp/store/sp/sim/",
    "terms": "https://www.ymobile.jp/store/sp/sim/",
    "supportUrl": "https://www.ymobile.jp/service/sumahosetup-support/",
    "fees": "通常初期費用：オンライン3850円／店頭4950円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [
      {
        "id": "set",
        "label": "自宅・家族の条件",
        "options": [
          {
            "id": "ymobile_hikari",
            "label": "おうち割 光セット(A)",
            "amount": 1650,
            "condition": "対象のSoftBank 光/光＋・Air契約と申込。固定回線等別途費用。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_family",
              "ymobile_denki_tbd",
              "ymobile_cho_otoku"
            ]
          },
          {
            "id": "ymobile_family",
            "label": "家族割引サービス",
            "amount": 1100,
            "condition": "2回線目以降、最大9回線。家族確認。1回線目は対象外。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_hikari",
              "ymobile_denki_tbd",
              "ymobile_cho_otoku"
            ]
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "ymobile_card",
            "label": "PayPayカード割",
            "amount": 330,
            "condition": "PayPayカードを料金支払方法に設定。ゴールドとは択一。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_card_gold"
            ]
          },
          {
            "id": "ymobile_card_gold",
            "label": "PayPayカード ゴールド割（増額分込み）",
            "amount": 770,
            "condition": "PayPayカード ゴールド支払。550円＋2026-06-02以降増額220円。年会費11000円別途。旧契約向け特別割引とは増額特典併用不可。 増額220円の適用期間は2026-06-02～終了日未定。契約後12ヶ月等の固定期間制限は記載なし、永年保証ではない。請求締日時点に対象プラン・Gold支払・PayPayカード割適用が必要。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_card"
            ]
          }
        ]
      }
    ],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "ymobile_simple3_l",
    "base": 5478,
    "gb": 35,
    "short": 0,
    "shortMinutes": 10,
    "long": 1100,
    "includedMinutes": 10,
    "shop": true,
    "discounts": [
      {
        "sourceId": "ymobile_hikari",
        "amount": 1650,
        "condition": "対象のSoftBank 光/光＋・Air契約と申込。固定回線等別途費用。",
        "exclusive": [
          "ymobile_family",
          "ymobile_denki_tbd",
          "ymobile_cho_otoku"
        ]
      },
      {
        "sourceId": "ymobile_family",
        "amount": 1100,
        "condition": "2回線目以降、最大9回線。家族確認。1回線目は対象外。",
        "exclusive": [
          "ymobile_hikari",
          "ymobile_denki_tbd",
          "ymobile_cho_otoku"
        ]
      },
      {
        "sourceId": "ymobile_card",
        "amount": 330,
        "condition": "PayPayカードを料金支払方法に設定。ゴールドとは択一。",
        "exclusive": [
          "ymobile_card_gold"
        ]
      },
      {
        "sourceId": "ymobile_card_gold",
        "amount": 770,
        "condition": "PayPayカード ゴールド支払。550円＋2026-06-02以降増額220円。年会費11000円別途。旧契約向け特別割引とは増額特典併用不可。 増額220円の適用期間は2026-06-02～終了日未定。契約後12ヶ月等の固定期間制限は記載なし、永年保証ではない。請求締日時点に対象プラン・Gold支払・PayPayカード割適用が必要。",
        "exclusive": [
          "ymobile_card"
        ],
        "bonusStart": "2026-06-02",
        "bonusEnd": null,
        "bonusEndStatus": "終了日未定",
        "sourceUrl": "https://www.ymobile.jp/corporate/open/agreement/pdf/paypay_card_bonus.pdf"
      }
    ],
    "notes": [
      "2026-06-02改定後基本料。旧契約向け特別割引を新規契約に適用しない。",
      "通常または定額超過22円/30秒。定額対象外番号あり。",
      "店舗での設定・データ移行は有料メニューあり。"
    ],
    "sourceUrls": [
      "https://www.ymobile.jp/store/sp/sim/",
      "https://www.ymobile.jp/jusetsu/jusetsu06/",
      "https://www.ymobile.jp/plan/discount/kazokuwari/",
      "https://www.ymobile.jp/plan/discount/ouchiwari/?plan_type=simple1",
      "https://www.ymobile.jp/service/sumahosetup-support/",
      "https://www.ymobile.jp/jusetsu/servicenotes/service_notes.pdf"
    ],
    "initialFee": {
      "onlineStandard": 3850,
      "shop": 4950,
      "campaign": "9月30日までのオンライン手数料無料キャンペーンは終了。通常オンライン手数料3,850円で計算（2026-10-05確認）。"
    },
    "name": "シンプル3 L (35GB)",
    "brand": "Y!mobile",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://www.ymobile.jp/store/sp/sim/",
      "https://www.ymobile.jp/jusetsu/jusetsu06/",
      "https://www.ymobile.jp/plan/discount/kazokuwari/",
      "https://www.ymobile.jp/plan/discount/ouchiwari/?plan_type=simple1",
      "https://www.ymobile.jp/service/sumahosetup-support/",
      "https://www.ymobile.jp/jusetsu/servicenotes/service_notes.pdf"
    ],
    "url": "https://www.ymobile.jp/store/sp/sim/",
    "terms": "https://www.ymobile.jp/store/sp/sim/",
    "supportUrl": "https://www.ymobile.jp/service/sumahosetup-support/",
    "fees": "通常初期費用：オンライン3850円／店頭4950円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [
      {
        "id": "set",
        "label": "自宅・家族の条件",
        "options": [
          {
            "id": "ymobile_hikari",
            "label": "おうち割 光セット(A)",
            "amount": 1650,
            "condition": "対象のSoftBank 光/光＋・Air契約と申込。固定回線等別途費用。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_family",
              "ymobile_denki_tbd",
              "ymobile_cho_otoku"
            ]
          },
          {
            "id": "ymobile_family",
            "label": "家族割引サービス",
            "amount": 1100,
            "condition": "2回線目以降、最大9回線。家族確認。1回線目は対象外。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_hikari",
              "ymobile_denki_tbd",
              "ymobile_cho_otoku"
            ]
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "ymobile_card",
            "label": "PayPayカード割",
            "amount": 330,
            "condition": "PayPayカードを料金支払方法に設定。ゴールドとは択一。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_card_gold"
            ]
          },
          {
            "id": "ymobile_card_gold",
            "label": "PayPayカード ゴールド割（増額分込み）",
            "amount": 770,
            "condition": "PayPayカード ゴールド支払。550円＋2026-06-02以降増額220円。年会費11000円別途。旧契約向け特別割引とは増額特典併用不可。 増額220円の適用期間は2026-06-02～終了日未定。契約後12ヶ月等の固定期間制限は記載なし、永年保証ではない。請求締日時点に対象プラン・Gold支払・PayPayカード割適用が必要。",
            "url": "https://www.ymobile.jp/store/sp/sim/",
            "exclusive": [
              "ymobile_card"
            ]
          }
        ]
      }
    ],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "mineo_mypita_3gb",
    "base": 1298,
    "gb": 3,
    "short": 550,
    "shortMinutes": 10,
    "long": 1210,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3740,
    "notes": [
      "音声デュアルタイプ。容量超過後最大200kbps。",
      "店舗の対応内容は店舗ごとに異なり、初期設定は原則有料。",
      "かけ放題は対象外番号あり。"
    ],
    "sourceUrls": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "name": "マイピタ 3GB",
    "brand": "mineo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "url": "https://mineo.jp/price/",
    "terms": "https://mineo.jp/price/",
    "supportUrl": "https://mineo.jp/shop/about/",
    "fees": "通常初期費用3,740円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "mineo_mypita_7gb",
    "base": 1518,
    "gb": 7,
    "short": 550,
    "shortMinutes": 10,
    "long": 1210,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3740,
    "notes": [
      "音声デュアルタイプ。容量超過後最大200kbps。",
      "店舗の対応内容は店舗ごとに異なり、初期設定は原則有料。",
      "かけ放題は対象外番号あり。"
    ],
    "sourceUrls": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "name": "マイピタ 7GB",
    "brand": "mineo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "url": "https://mineo.jp/price/",
    "terms": "https://mineo.jp/price/",
    "supportUrl": "https://mineo.jp/shop/about/",
    "fees": "通常初期費用3,740円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "mineo_mypita_15gb",
    "base": 1958,
    "gb": 15,
    "short": 550,
    "shortMinutes": 10,
    "long": 1210,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3740,
    "notes": [
      "音声デュアルタイプ。容量超過後最大200kbps。",
      "店舗の対応内容は店舗ごとに異なり、初期設定は原則有料。",
      "かけ放題は対象外番号あり。"
    ],
    "sourceUrls": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "name": "マイピタ 15GB",
    "brand": "mineo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "url": "https://mineo.jp/price/",
    "terms": "https://mineo.jp/price/",
    "supportUrl": "https://mineo.jp/shop/about/",
    "fees": "通常初期費用3,740円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "mineo_mypita_30gb",
    "base": 2178,
    "gb": 30,
    "short": 550,
    "shortMinutes": 10,
    "long": 1210,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3740,
    "notes": [
      "音声デュアルタイプ。容量超過後最大200kbps。",
      "店舗の対応内容は店舗ごとに異なり、初期設定は原則有料。",
      "かけ放題は対象外番号あり。"
    ],
    "sourceUrls": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "name": "マイピタ 30GB",
    "brand": "mineo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "url": "https://mineo.jp/price/",
    "terms": "https://mineo.jp/price/",
    "supportUrl": "https://mineo.jp/shop/about/",
    "fees": "通常初期費用3,740円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "mineo_mypita_50gb",
    "base": 2948,
    "gb": 50,
    "short": 550,
    "shortMinutes": 10,
    "long": 1210,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3740,
    "notes": [
      "音声デュアルタイプ。容量超過後最大200kbps。",
      "店舗の対応内容は店舗ごとに異なり、初期設定は原則有料。",
      "かけ放題は対象外番号あり。"
    ],
    "sourceUrls": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "name": "マイピタ 50GB",
    "brand": "mineo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "url": "https://mineo.jp/price/",
    "terms": "https://mineo.jp/price/",
    "supportUrl": "https://mineo.jp/shop/about/",
    "fees": "通常初期費用3,740円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "mineo_mysoku_standard",
    "base": 990,
    "gb": null,
    "short": 550,
    "shortMinutes": 10,
    "long": 1210,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3740,
    "notes": [
      "最大1.5Mbps。月曜～金曜12～13時は最大32kbps。3日10GB以上で速度制限あり。高速大容量プランと同列に扱わない。",
      "店舗の対応内容は店舗ごとに異なり、初期設定は原則有料。"
    ],
    "sourceUrls": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "speedMbps": 1.5,
    "name": "マイそく スタンダード",
    "brand": "mineo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://mineo.jp/price/",
      "https://mineo.jp/shop/about/",
      "https://mineo.jp/apply/setup-flow/"
    ],
    "url": "https://mineo.jp/price/",
    "terms": "https://mineo.jp/price/",
    "supportUrl": "https://mineo.jp/shop/about/",
    "fees": "通常初期費用3,740円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "速度で選ぶプラン。高速データ無制限とは異なります。",
    "speedLimited": true,
    "feeBasis": "monthly",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "aeon_5gb",
    "base": 1298,
    "gb": 5,
    "short": 550,
    "shortMinutes": 5,
    "long": 1650,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3300,
    "notes": [
      "音声プラン・年齢条件なし通常料金。",
      "5分550円、10分935円、フル1650円。対象外番号あり。",
      "イオンモバイルショップで相談可能。パッケージ販売のみの店舗は相談不可。"
    ],
    "sourceUrls": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "name": "さいてきプラン 5GB",
    "brand": "イオンモバイル",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 11,
    "sources": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "url": "https://aeonmobile.jp/plan/",
    "terms": "https://aeonmobile.jp/plan/",
    "supportUrl": "https://aeonmobile.jp/shoplist/",
    "fees": "通常初期費用3,300円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "イオンゴールドカード割はカード請求時5%引き。対象費用・併用条件があるため、この試算には含みません。",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "aeon_10gb",
    "base": 1848,
    "gb": 10,
    "short": 550,
    "shortMinutes": 5,
    "long": 1650,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3300,
    "notes": [
      "音声プラン・年齢条件なし通常料金。",
      "5分550円、10分935円、フル1650円。対象外番号あり。",
      "イオンモバイルショップで相談可能。パッケージ販売のみの店舗は相談不可。"
    ],
    "sourceUrls": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "name": "さいてきプラン 10GB",
    "brand": "イオンモバイル",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 11,
    "sources": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "url": "https://aeonmobile.jp/plan/",
    "terms": "https://aeonmobile.jp/plan/",
    "supportUrl": "https://aeonmobile.jp/shoplist/",
    "fees": "通常初期費用3,300円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "イオンゴールドカード割はカード請求時5%引き。対象費用・併用条件があるため、この試算には含みません。",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "aeon_20gb",
    "base": 1958,
    "gb": 20,
    "short": 550,
    "shortMinutes": 5,
    "long": 1650,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3300,
    "notes": [
      "音声プラン・年齢条件なし通常料金。",
      "5分550円、10分935円、フル1650円。対象外番号あり。",
      "イオンモバイルショップで相談可能。パッケージ販売のみの店舗は相談不可。"
    ],
    "sourceUrls": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "name": "さいてきプラン 20GB",
    "brand": "イオンモバイル",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 11,
    "sources": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "url": "https://aeonmobile.jp/plan/",
    "terms": "https://aeonmobile.jp/plan/",
    "supportUrl": "https://aeonmobile.jp/shoplist/",
    "fees": "通常初期費用3,300円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "イオンゴールドカード割はカード請求時5%引き。対象費用・併用条件があるため、この試算には含みません。",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "aeon_30gb",
    "base": 2508,
    "gb": 30,
    "short": 550,
    "shortMinutes": 5,
    "long": 1650,
    "includedMinutes": 0,
    "periodDays": null,
    "shop": true,
    "initialFee": 3300,
    "notes": [
      "音声プラン・年齢条件なし通常料金。",
      "5分550円、10分935円、フル1650円。対象外番号あり。",
      "イオンモバイルショップで相談可能。パッケージ販売のみの店舗は相談不可。"
    ],
    "sourceUrls": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "name": "さいてきプラン 30GB",
    "brand": "イオンモバイル",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 11,
    "sources": [
      "https://aeonmobile.jp/plan/",
      "https://aeonmobile.jp/pdf/plans_all.pdf",
      "https://faq.aeonmobile.jp/faq/show/1051?category_id=92&site_domain=default",
      "https://aeonmobile.jp/shoplist/",
      "https://aeonmobile.jp/guide/"
    ],
    "url": "https://aeonmobile.jp/plan/",
    "terms": "https://aeonmobile.jp/plan/",
    "supportUrl": "https://aeonmobile.jp/shoplist/",
    "fees": "通常初期費用3,300円。",
    "support": "店舗により対応範囲や設定支援の料金が異なります。",
    "discountGroups": [],
    "priceNote": "",
    "speedLimited": false,
    "feeBasis": "monthly",
    "discountNotice": "イオンゴールドカード割はカード請求時5%引き。対象費用・併用条件があるため、この試算には含みません。",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "povo_3gb_30d",
    "base": 990,
    "gb": 3,
    "short": 550,
    "shortMinutes": 5,
    "long": 1650,
    "includedMinutes": 0,
    "periodDays": 30,
    "shop": false,
    "initialFee": 0,
    "notes": [
      "データ料金は30日間の都度購入で暦月料金ではない。通話トッピングは月額。合算時も周期が異なる。",
      "通常国内通話22円/30秒。かけ放題対象外番号あり。",
      "180日間以上有料トッピング購入等がない場合、利用停止・契約解除の場合あり。0GB時最大128kbps。",
      "過去1年以内に同一名義累計5回線以上申込の場合、契約事務手数料3850円。",
      "オンラインサポート。"
    ],
    "sourceUrls": [
      "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
      "https://povo.jp/topping-list/detail/30G_30d/",
      "https://povo.jp/topping-list/detail/5-kakeho/",
      "https://povo.jp/topping-list/detail/kakeho/",
      "https://povo.jp/information/",
      "https://faq.povo.jp/faq/show/575?category_id=45&site_domain=default"
    ],
    "name": "povo 3GB (30日)",
    "brand": "povo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
      "https://povo.jp/topping-list/detail/30G_30d/",
      "https://povo.jp/topping-list/detail/5-kakeho/",
      "https://povo.jp/topping-list/detail/kakeho/",
      "https://povo.jp/information/",
      "https://faq.povo.jp/faq/show/575?category_id=45&site_domain=default"
    ],
    "url": "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
    "terms": "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
    "supportUrl": "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
    "fees": "通常初期費用0円。",
    "support": "オンラインでの手続き・サポート。",
    "discountGroups": [],
    "priceNote": "データは30日間の都度購入。通話は暦月契約で、料金の周期が異なります。",
    "speedLimited": false,
    "feeBasis": "30days",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "povo_30gb_30d",
    "base": 2780,
    "gb": 30,
    "short": 550,
    "shortMinutes": 5,
    "long": 1650,
    "includedMinutes": 0,
    "periodDays": 30,
    "shop": false,
    "initialFee": 0,
    "notes": [
      "データ料金は30日間の都度購入で暦月料金ではない。通話トッピングは月額。合算時も周期が異なる。",
      "通常国内通話22円/30秒。かけ放題対象外番号あり。",
      "180日間以上有料トッピング購入等がない場合、利用停止・契約解除の場合あり。0GB時最大128kbps。",
      "過去1年以内に同一名義累計5回線以上申込の場合、契約事務手数料3850円。",
      "オンラインサポート。"
    ],
    "sourceUrls": [
      "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
      "https://povo.jp/topping-list/detail/30G_30d/",
      "https://povo.jp/topping-list/detail/5-kakeho/",
      "https://povo.jp/topping-list/detail/kakeho/",
      "https://povo.jp/information/",
      "https://faq.povo.jp/faq/show/575?category_id=45&site_domain=default"
    ],
    "name": "povo 30GB (30日)",
    "brand": "povo",
    "checked": "2026-09-11",
    "status": "verified",
    "rate": 22,
    "sources": [
      "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
      "https://povo.jp/topping-list/detail/30G_30d/",
      "https://povo.jp/topping-list/detail/5-kakeho/",
      "https://povo.jp/topping-list/detail/kakeho/",
      "https://povo.jp/information/",
      "https://faq.povo.jp/faq/show/575?category_id=45&site_domain=default"
    ],
    "url": "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
    "terms": "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
    "supportUrl": "https://povo.jp/cms/povo/conditions/260528_datatopping_2.pdf",
    "fees": "通常初期費用0円。",
    "support": "オンラインでの手続き・サポート。",
    "discountGroups": [],
    "priceNote": "データは30日間の都度購入。通話は暦月契約で、料金の周期が異なります。",
    "speedLimited": false,
    "feeBasis": "30days",
    "discountNotice": "",
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_max_unlimited",
    "name": "ドコモ MAX（無制限）",
    "brand": "ドコモ",
    "base": 8448,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_max/"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_max/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_max/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_max/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "使用量に応じた段階制。無制限も大量通信時に制限あり。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "docomo_family2",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線2回線",
            "condition": "カウント対象回線2回線",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_family3",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線3回線以上",
            "condition": "カウント対象回線3回線以上",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "loyalty",
        "label": "契約の継続年数",
        "options": [
          {
            "id": "docomo_long10",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続10年以上20年未満",
            "condition": "継続10年以上20年未満",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_long20",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続20年以上",
            "condition": "継続20年以上",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_max_3gb",
    "name": "ドコモ MAX（1GB超~3GB）",
    "brand": "ドコモ",
    "base": 6798,
    "gb": 3,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_max/"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_max/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_max/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_max/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "使用量に応じた段階制。無制限も大量通信時に制限あり。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "docomo_family2",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線2回線",
            "condition": "カウント対象回線2回線",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_family3",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線3回線以上",
            "condition": "カウント対象回線3回線以上",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "loyalty",
        "label": "契約の継続年数",
        "options": [
          {
            "id": "docomo_long10",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続10年以上20年未満",
            "condition": "継続10年以上20年未満",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_long20",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続20年以上",
            "condition": "継続20年以上",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_max_1gb",
    "name": "ドコモ MAX（~1GB）",
    "brand": "ドコモ",
    "base": 5698,
    "gb": 1,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_max/"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_max/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_max/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_max/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "使用量に応じた段階制。無制限も大量通信時に制限あり。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "docomo_family2",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線2回線",
            "condition": "カウント対象回線2回線",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_family3",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線3回線以上",
            "condition": "カウント対象回線3回線以上",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      },
      {
        "id": "loyalty",
        "label": "契約の継続年数",
        "options": [
          {
            "id": "docomo_long10",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続10年以上20年未満",
            "condition": "継続10年以上20年未満",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          },
          {
            "id": "docomo_long20",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続20年以上",
            "condition": "継続20年以上",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_max/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_mini_10gb",
    "name": "ドコモ mini 12GB（増量中）",
    "brand": "ドコモ",
    "base": 3850,
    "gb": 12,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-18",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_mini/",
      "https://www.docomo.ne.jp/info/notice/page/260729_00.html"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_mini/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_mini/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_mini/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "通常10GB。2026-08-01から2GB増量キャンペーンにより12GBへ増量中。終了後は通常容量に戻ります。家族間通話無料とみんなドコモ割の割引対象外。"
    ],
    "priceNote": "",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_mini_4gb",
    "name": "ドコモ mini 6GB（増量中）",
    "brand": "ドコモ",
    "base": 2750,
    "gb": 6,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-18",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_mini/",
      "https://www.docomo.ne.jp/info/notice/page/260729_00.html"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_mini/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_mini/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_mini/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "通常4GB。2026-08-01から2GB増量キャンペーンにより6GBへ増量中。終了後は通常容量に戻ります。家族間通話無料とみんなドコモ割の割引対象外。"
    ],
    "priceNote": "",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_mini/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_poikatsu_max",
    "name": "ドコモ ポイ活 MAX",
    "brand": "ドコモ",
    "base": 11748,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "ポイント還元は料金割引と別。2026年12月利用分からポイント進呈条件改定予定。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "docomo_family2",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線2回線",
            "condition": "カウント対象回線2回線",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          },
          {
            "id": "docomo_family3",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線3回線以上",
            "condition": "カウント対象回線3回線以上",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          }
        ]
      },
      {
        "id": "loyalty",
        "label": "契約の継続年数",
        "options": [
          {
            "id": "docomo_long10",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続10年以上20年未満",
            "condition": "継続10年以上20年未満",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          },
          {
            "id": "docomo_long20",
            "sourceDiscountId": "docomo_long_current_v13",
            "label": "継続20年以上",
            "condition": "継続20年以上",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_max/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_poikatsu_20_20gb",
    "name": "ドコモ ポイ活 20（~20GB）",
    "brand": "ドコモ",
    "base": 7898,
    "gb": 20,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "20GBを超えると9570円。ポイント還元は別。2026年12月利用分からポイント進呈条件改定予定。"
    ],
    "priceNote": "",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "docomo_family2",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線2回線",
            "condition": "カウント対象回線2回線",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          },
          {
            "id": "docomo_family3",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線3回線以上",
            "condition": "カウント対象回線3回線以上",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "docomo_poikatsu_20_unlimited",
    "name": "ドコモ ポイ活 20（無制限）",
    "brand": "ドコモ",
    "base": 9570,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
    ],
    "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/",
    "terms": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/",
    "supportUrl": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "20GBを超えると9570円。ポイント還元は別。2026年12月利用分からポイント進呈条件改定予定。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "docomo_card_regular",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカードで支払い",
            "condition": "dカードで支払い",
            "amount": 220,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          },
          {
            "id": "docomo_card_gold",
            "sourceDiscountId": "docomo_card_current_v13",
            "label": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "condition": "dカード GOLD/GOLD U/PLATINUMで支払い。年会費別途",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      },
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "docomo_home",
            "sourceDiscountId": "docomo_hikari_home5g_current_v13",
            "label": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "condition": "同一ファミリー割引グループにドコモ光またはhome 5G契約。回線費用別途",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      },
      {
        "id": "power",
        "label": "電気の契約",
        "options": [
          {
            "id": "docomo_power",
            "sourceDiscountId": "docomo_denki_current_v13",
            "label": "同一ファミリー割引グループにドコモでんきのペア回線",
            "condition": "同一ファミリー割引グループにドコモでんきのペア回線",
            "amount": 110,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "docomo_family2",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線2回線",
            "condition": "カウント対象回線2回線",
            "amount": 550,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          },
          {
            "id": "docomo_family3",
            "sourceDiscountId": "docomo_family",
            "label": "カウント対象回線3回線以上",
            "condition": "カウント対象回線3回線以上",
            "amount": 1210,
            "url": "https://www.docomo.ne.jp/charge/docomo_poikatsu_20/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_value_link",
    "name": "auバリューリンクプラン",
    "brand": "au",
    "base": 8008,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "200GB/月超で最大5Mbps。テザリング等は60GB（ALL STARは100GB）。1GB以下自動割引は今回料金計算から除外。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "au_family2",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象2人",
            "condition": "家族割プラス対象2人",
            "amount": 660,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/"
          },
          {
            "id": "au_family3",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象3人以上",
            "condition": "家族割プラス対象3人以上",
            "amount": 1210,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "au_card",
            "sourceDiscountId": "au_card_current_v13",
            "label": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "condition": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "amount": 220,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_unlimited_max_plus",
    "name": "使い放題MAX+ 5G/4G",
    "brand": "au",
    "base": 7788,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "200GB/月超で最大5Mbps。テザリング等は60GB（ALL STARは100GB）。1GB以下自動割引は今回料金計算から除外。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "au_family2",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象2人",
            "condition": "家族割プラス対象2人",
            "amount": 660,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/"
          },
          {
            "id": "au_family3",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象3人以上",
            "condition": "家族割プラス対象3人以上",
            "amount": 1210,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "au_card",
            "sourceDiscountId": "au_card_current_v13",
            "label": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "condition": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "amount": 220,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_value_link_allstar",
    "name": "使い放題MAX＋ 5G ALL STARパック",
    "brand": "au",
    "base": 11836,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "200GB/月超で最大5Mbps。テザリング等は60GB（ALL STARは100GB）。1GB以下自動割引は今回料金計算から除外。",
      "Apple Music料金改定に伴う今後のプラン改定予告あり。改定額未定。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "au_family2",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象2人",
            "condition": "家族割プラス対象2人",
            "amount": 660,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/"
          },
          {
            "id": "au_family3",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象3人以上",
            "condition": "家族割プラス対象3人以上",
            "amount": 1210,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "au_card",
            "sourceDiscountId": "au_card_current_v13",
            "label": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "condition": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "amount": 220,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/data-unlimited-plus-allstar/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_value_link_moneyact2",
    "name": "auバリューリンク マネ活2",
    "brand": "au",
    "base": 9328,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink-moneyact2/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink-moneyact2/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink-moneyact2/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink-moneyact2/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "金融・決済還元を月額料金から自動控除しない。法人不可。200GB超で最大5Mbps。テザリング60GB。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/auvaluelink-moneyact2/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_smartmini_plus_1gb",
    "name": "スマホミニプラン＋ 5G/4G（~1GB）",
    "brand": "au",
    "base": 4928,
    "gb": 1,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "利用量に応じた3段階制。5GB超は最大300kbps。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "au_family2",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象2人",
            "condition": "家族割プラス対象2人",
            "amount": 660,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          },
          {
            "id": "au_family3",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象3人以上",
            "condition": "家族割プラス対象3人以上",
            "amount": 1210,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "au_card",
            "sourceDiscountId": "au_card_current_v13",
            "label": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "condition": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "amount": 220,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_smartmini_plus_3gb",
    "name": "スマホミニプラン＋ 5G/4G（1GB超~3GB）",
    "brand": "au",
    "base": 6578,
    "gb": 3,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "利用量に応じた3段階制。5GB超は最大300kbps。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "au_family2",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象2人",
            "condition": "家族割プラス対象2人",
            "amount": 660,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          },
          {
            "id": "au_family3",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象3人以上",
            "condition": "家族割プラス対象3人以上",
            "amount": 1210,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "au_card",
            "sourceDiscountId": "au_card_current_v13",
            "label": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "condition": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "amount": 220,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "au_smartmini_plus_5gb",
    "name": "スマホミニプラン＋ 5G/4G（3GB超~5GB）",
    "brand": "au",
    "base": 8228,
    "gb": 5,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
    ],
    "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "terms": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "supportUrl": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "利用量に応じた3段階制。5GB超は最大300kbps。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "au_home",
            "sourceDiscountId": "au_smartvalue_current_v13",
            "label": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "condition": "対象インターネット等とauスマートバリュー。固定回線費用別途",
            "amount": 1100,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "au_family2",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象2人",
            "condition": "家族割プラス対象2人",
            "amount": 660,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          },
          {
            "id": "au_family3",
            "sourceDiscountId": "au_family_current_v13",
            "label": "家族割プラス対象3人以上",
            "condition": "家族割プラス対象3人以上",
            "amount": 1210,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "au_card",
            "sourceDiscountId": "au_card_current_v13",
            "label": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "condition": "au PAY カードお支払い割。スマイルハート割引と重畳不可",
            "amount": 220,
            "url": "https://www.au.com/mobile/charge/smartphone/plan/sp-mini-plus/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "sb_paytoku2_unlimited",
    "name": "ペイトク2",
    "brand": "ソフトバンク",
    "base": 10538,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.softbank.jp/mobile/price_plan/data/paytoku2/",
      "https://www.softbank.jp/mobile/set/common/pdf/legal/spguide/price_plan/tsuwakihon-plan-options-plus.pdf"
    ],
    "url": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/",
    "terms": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/",
    "supportUrl": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "ポイント還元別計算。法人不可。直近30日300GB超は最大4.5Mbps。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "sb_home",
            "sourceDiscountId": "softbank_hikari_current_v13",
            "label": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "condition": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "amount": 1100,
            "url": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "sb_card_regular",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードで支払い",
            "condition": "PayPayカードで支払い",
            "amount": 330,
            "url": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/"
          },
          {
            "id": "sb_card_gold",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードゴールドで支払い。年会費11000円別途",
            "condition": "PayPayカードゴールドで支払い。年会費11000円別途",
            "amount": 550,
            "url": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "sb_family3",
            "sourceDiscountId": "softbank_family_current_v13",
            "label": "新みんな家族割3回線以上",
            "condition": "新みんな家族割3回線以上",
            "amount": 1210,
            "url": "https://www.softbank.jp/mobile/price_plan/data/paytoku2/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "sb_teigaku_unlimited_unlimited",
    "name": "テイガク無制限",
    "brand": "ソフトバンク",
    "base": 8008,
    "gb": null,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/",
      "https://www.softbank.jp/mobile/set/common/pdf/legal/spguide/price_plan/tsuwakihon-plan-options-plus.pdf"
    ],
    "url": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/",
    "terms": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/",
    "supportUrl": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "容量にかかわらず定額。旧DBの3GB超という区分を削除。毎月200ポイントは月額割引とは別。直近30日300GB超は最大4.5Mbps。"
    ],
    "priceNote": "データ量・混雑状況による速度制御や、テザリングの上限があります。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "sb_home",
            "sourceDiscountId": "softbank_hikari_current_v13",
            "label": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "condition": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "amount": 1100,
            "url": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "sb_card_regular",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードで支払い",
            "condition": "PayPayカードで支払い",
            "amount": 330,
            "url": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/"
          },
          {
            "id": "sb_card_gold",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードゴールドで支払い。年会費11000円別途",
            "condition": "PayPayカードゴールドで支払い。年会費11000円別途",
            "amount": 550,
            "url": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "sb_family3",
            "sourceDiscountId": "softbank_family_current_v13",
            "label": "新みんな家族割3回線以上",
            "condition": "新みんな家族割3回線以上",
            "amount": 1210,
            "url": "https://www.softbank.jp/mobile/price_plan/data/teigaku-museigen/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "sb_minifit2_2gb",
    "name": "ミニフィット2（～2GB）",
    "brand": "ソフトバンク",
    "base": 5258,
    "gb": 2,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
      "https://www.softbank.jp/mobile/set/common/pdf/legal/spguide/price_plan/tsuwakihon-plan-options-plus.pdf"
    ],
    "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
    "terms": "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
    "supportUrl": "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "正式名はミニフィット2。旧DBのミニフィットプラン2を修正。利用量で2段階。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "sb_home",
            "sourceDiscountId": "softbank_hikari_current_v13",
            "label": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "condition": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "amount": 1100,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "sb_card_regular",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードで支払い",
            "condition": "PayPayカードで支払い",
            "amount": 330,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          },
          {
            "id": "sb_card_gold",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードゴールドで支払い。年会費11000円別途",
            "condition": "PayPayカードゴールドで支払い。年会費11000円別途",
            "amount": 550,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "sb_mini_family2",
            "sourceDiscountId": "softbank_family_current_v13",
            "label": "新みんな家族割2回線",
            "condition": "新みんな家族割2回線",
            "amount": 220,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          },
          {
            "id": "sb_mini_family3",
            "sourceDiscountId": "softbank_family_current_v13",
            "label": "新みんな家族割3回線以上",
            "condition": "新みんな家族割3回線以上",
            "amount": 550,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  },
  {
    "id": "sb_minifit2_5gb",
    "name": "ミニフィット2（～5GB）",
    "brand": "ソフトバンク",
    "base": 6358,
    "gb": 5,
    "short": 880,
    "long": 1980,
    "shortMinutes": 5,
    "includedMinutes": 0,
    "shop": true,
    "rate": 22,
    "checked": "2026-09-11",
    "status": "verified",
    "sources": [
      "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
      "https://www.softbank.jp/mobile/set/common/pdf/legal/spguide/price_plan/tsuwakihon-plan-options-plus.pdf"
    ],
    "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
    "terms": "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
    "supportUrl": "https://www.softbank.jp/mobile/price_plan/data/minifit2/",
    "support": "ショップで相談可能。設定・データ移行などは有料の場合があります。",
    "fees": "契約事務手数料は申込方法・経路で異なります。公式の申込条件をご確認ください。",
    "notes": [
      "通話定額には0570等の対象外通話あり。超過通常22円/30秒。",
      "正式名はミニフィット2。旧DBのミニフィットプラン2を修正。利用量で2段階。"
    ],
    "priceNote": "同じプランの利用量に応じた料金段階です。",
    "discountGroups": [
      {
        "id": "home",
        "label": "自宅のインターネット",
        "options": [
          {
            "id": "sb_home",
            "sourceDiscountId": "softbank_hikari_current_v13",
            "label": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "condition": "対象固定回線とおうち割光セット。SoftBank光は指定オプション等別途",
            "amount": 1100,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          }
        ]
      },
      {
        "id": "card",
        "label": "支払いカード",
        "options": [
          {
            "id": "sb_card_regular",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードで支払い",
            "condition": "PayPayカードで支払い",
            "amount": 330,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          },
          {
            "id": "sb_card_gold",
            "sourceDiscountId": "softbank_card_current_v13",
            "label": "PayPayカードゴールドで支払い。年会費11000円別途",
            "condition": "PayPayカードゴールドで支払い。年会費11000円別途",
            "amount": 550,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          }
        ]
      },
      {
        "id": "family",
        "label": "家族回線",
        "options": [
          {
            "id": "sb_mini_family2",
            "sourceDiscountId": "softbank_family_current_v13",
            "label": "新みんな家族割2回線",
            "condition": "新みんな家族割2回線",
            "amount": 220,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          },
          {
            "id": "sb_mini_family3",
            "sourceDiscountId": "softbank_family_current_v13",
            "label": "新みんな家族割3回線以上",
            "condition": "新みんな家族割3回線以上",
            "amount": 550,
            "url": "https://www.softbank.jp/mobile/price_plan/data/minifit2/"
          }
        ]
      }
    ],
    "affiliateStatus": "未確認",
    "affiliateUrl": null
  }
] as MobilePlan[];
